import React, { useContext } from "react";
import { Badge, Layout, Menu } from "antd";
import "./accountcenter.css";
import { AccessControl } from "./AccessControl";
import { ProgressIndicator } from "@fluentui/react";
import { observer } from "mobx-react-lite";
import AccountStore from "../store/accountStore";
import { RejectRequestDialog } from "./RejectRequestDialog";
import { Accounts } from "./Accounts";
import { PermissionBaseView } from "../../permission/component/PermissionBaseView";
const { Content, Sider } = Layout;

export const AccountCenterBaseView = observer(() => {
  const accountStore = useContext(AccountStore);

  const renderChildren = () => {
    const selectKey = accountStore.selectedTab;
    switch (selectKey) {
      case "1":
        return <AccessControl />;

      case "2":
        return <Accounts />;
      case "3":
        return <PermissionBaseView />;
      case "4":
        return <div>SPARS Configurations</div>;
      default:
        break;
    }

    return null;
  };
  return (
    <Layout>
      <Content>
        <Layout style={{ padding: "24px 0", background: "#fff" }}>
          <Sider width={200} style={{ background: "#fff" }}>
            <Menu
              mode="inline"
              defaultSelectedKeys={[accountStore.selectedTab]}
              defaultOpenKeys={["sub1"]}
              style={{ height: "100%", width: "224px" }}
              onClick={({ key }) => {
                accountStore.selectedTab = key;
              }}
            >
              <Menu.Item key="1">
                <span>Account Requests</span>{" "}
                {accountStore.accountRequests.size > 0 && (
                  <Badge color="red" style={{ marginLeft: "-5px" }} />
                )}
              </Menu.Item>
              <Menu.Item key="2">
                <span>SPARS Accounts</span>
              </Menu.Item>
              <Menu.Item key="3">
                {" "}
                <span>Groups and Permissions</span>
              </Menu.Item>
              <Menu.Item key="4">
                <span>SPARS Configurations</span>
              </Menu.Item>
            </Menu>
          </Sider>

          <Content>
            <div className="ms-Grid" dir="ltr">
              {accountStore.isworking && (
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm12">
                    {" "}
                    <ProgressIndicator
                      description="processing, please wait..."
                      styles={{ root: { textAlign: "center" } }}
                    ></ProgressIndicator>
                  </div>
                </div>
              )}
              <div className="ms-Grid-row" style={{ paddingLeft: "24px" }}>
                <div className="ms-Grid-col ms-sm12">{renderChildren()}</div>
              </div>
            </div>
          </Content>
        </Layout>
        <RejectRequestDialog />
      </Content>
    </Layout>
  );
});

